import VideoPlaybackOptions from "@core/libs/video_playback_options";

export {};

const episodesPlaceholder = document.getElementById('season_episodes');

let bookmark: {startingEpisodeId: number, percent: number} | null = null;
let categoryId = 0;
let episodeId = 0;
let voyokey = '';
let playingEpisodeId = 0;
let episodesSplide: any;

document.addEventListener('started', async () => {
    voyokey = app.html.getData('.category_page', 'voyokey');
    categoryId = +app.html.getData('.category_page', 'categoryId')
    episodeId = +app.html.getData('.category_page', 'episodeId');

    if (!voyokey || !categoryId) {
        return;
    }

    if (typeof Splide !== 'undefined') {
        new Splide('.splide.seasons').mount();
    }

    app.voyoVideo.stopVideoPlayers();
    app.voyo.playTrailer('.category_page');
});

document.addEventListener('started-bookmarks', async () => {
    if (app.bookmarks.isBookmarked('GRP_DEFAULT', voyokey)) {
        app.html.addClass('.category_page', 'myVoyo');
    }

    const hasSeasonParam = new URLSearchParams(window.location.search).get('season');
    
    if (!hasSeasonParam) {
        bookmark = await app.bookmarks.voyoCategoryStartWith(voyokey);
        showBookmarkInfo(episodeId, categoryId);
    }
});

async function showBookmarkInfo(episodeId: number, categoryId: number): Promise<void> {
    // Show progress bar on the bookmarked episode. Exit early if there is no bookmark.
    if (!bookmark || !bookmark.startingEpisodeId) {
        return;
    }

    // Show progress bar in episode thumbnails inside season box.
    showEpisodeProgress(bookmark.startingEpisodeId, bookmark.percent);

    // Show bookmark UI (progress bar, 'Continue' instead of 'Play') on the category
    // page (episodeId 0) or when viewing the exact episode stored in the bookmark.
    if (episodeId && bookmark.startingEpisodeId !== episodeId) {
        // A specific episode is shown that doesn't match the bookmark — skip bookmark UI.
        return;
    }

    app.html.addClass('.category_page', 'stayedAt');
    app.html.setStyle('.category_info .progressbar .line', 'width', bookmark.percent + '%');
    app.html.addClass('.category_info .progressbar', 'progressbar--active');

    // Switch to the season that contains the bookmarked episode, if it's not already selected.
    const bookmarkEpisodeSeason = getEpisodeSeason(bookmark.startingEpisodeId);
    const currentSeason = app.html.getData('.season.selected', 'season');

    if (bookmarkEpisodeSeason && bookmarkEpisodeSeason !== currentSeason) {
        await onSeasonClick('voyocategory/' + categoryId, bookmarkEpisodeSeason)
    }

    // Append episode label (e.g. S02E13) to the 'Continue playing' button
    const seasonEpisodeShort = app.html.getData('.episode[data-uniq="'+bookmark.startingEpisodeId+'"]', 'seasonEpisodeShort');
    if (seasonEpisodeShort) {
        app.html.appendHTML('#continue_btn', ' ' + seasonEpisodeShort);
    }

    // User needs to watch his bookmarked episode and not the first one as is by default in html
    const linkToEpisode = app.html.q('#continue_btn')?.closest('a');
    if (linkToEpisode) {
        linkToEpisode.onclick = () => { onPlayClick(bookmark?.startingEpisodeId.toString() || ''); return false };
    }

    // Stop Watching button must work on bookmarked episode
    const linkToStopWatching = app.html.q('#stop_watching_btn')?.closest('a');
    if (linkToStopWatching) {
        linkToStopWatching.onclick = () => { stopWatching(bookmark?.startingEpisodeId.toString() || ''); return false };
    }

    // Remove avod_locked css class. This class is set if first episode is not for avod. But because user
    // has active bookmark, it means user had access for it, he watched it, episode was not locked. So let's
    // unlock it.
    app.html.removeClass('.info_buttons', 'avod_locked');
}

function showEpisodeProgress(episodeId: number, percent: number): void {
    const progressbar = '.episode[data-uniq="' + episodeId + '"] .progressbar';

    app.html.setStyle(progressbar + ' .line', 'width', percent + '%');
    app.html.addClass(progressbar, 'progressbar--active');
    app.html.show(progressbar);
}

function getEpisodeSeason(episodeId: number): string {
    const episodeIdsBySeason = JSON.parse(app.html.getData('.category_page', 'seasonEpisodes') || '[]') as Array<{Season: string, MediaIds: Array<number>}>;

    for (const season of episodeIdsBySeason) {
        if (season.MediaIds && season.MediaIds.includes(episodeId)) {
            return season.Season;
        }
    }

    return '';
}

function onPlayClick(episodeId: string, forAVOD: string = ''): void {
    if (!window.app) {
        return;
    }

    if (!app.user.loginGuard()) {
        return;
    }

    const urlPrefix = app.html.getData('body', 'urlPrefix');
    const url = urlPrefix + '/play/category/' + categoryId + '/episodes/' + episodeId;

    if (!app.user.user?.isSubscribed) {
        document.location.href = config.routes.activation;
        return;
    }

    if (app.playRestriction.restrictAppPlayback()) {
        return;
    }

    // This has to be here because we have to exit before #content is removed.
    if (!app.voyo.avodOK(forAVOD)) {
        app.goUpgrade(episodeId);
        return;
    }

    app.voyoVideo.stopVideoPlayers();

    app.html.q('#content')?.remove();
    app.html.addClass('body', 'playing_content');

    playEpisode(episodeId, url, forAVOD);
}

function playEpisode(episodeId: string, url: string, forAVOD: string = ''): void {
    if (!window.app) {
        return;
    }

    // Switching episode would skip the ad.
    if (app.voyoAds.isAdPlaying) {
        return;
    }

    if (!app.voyo.avodOK(forAVOD)) {
        app.goUpgrade(episodeId);
        return;
    }

    playingEpisodeId = +episodeId;

    app.voyoVideo.hideVideoControls();
    app.html.removeClass('.video__container', 'video__container--open');

    // loadEpisode retrieves the play-page HTML for #category_play (video data,
    // seasons, episode slider). Splides have to be remounted after the swap.
    app.voyoVideo.loadEpisode(url, '#category_play')
        .then(() => {
            mountPlayerSplides();
            markPlayingEpisode(playingEpisodeId);
            startPlayingEpisode(playingEpisodeId);
        });
}

function startPlayingEpisode(mediaId: number): void {
    const playbackOptions: VideoPlaybackOptions = {};

    const nextEpisodeUrl = app.html.getData('.player_box video', 'nextEpisodeUrl');
    if (nextEpisodeUrl) {
        playbackOptions.nextEpisodeUrl = nextEpisodeUrl;
    }

    const nextEpisodeId = app.html.getData('.player_box video', 'nextEpisodeId');
    if (nextEpisodeId) {
        playbackOptions.nextEpisodeId = +nextEpisodeId;
    }

    playInPlace(mediaId, playbackOptions);
}

function playInPlace(mediaId: number, playbackOptions: VideoPlaybackOptions = {}): void {
    if (!window.app) {
        return;
    }

    if (app.playRestriction.restrictAppPlayback()) {
        return;
    }

    app.voyoVideo.stopVideoPlayers();
    app.html.addClass('body', 'playing_content');

    const bookmark = app.bookmarks.isBookmarked('stayedAt', mediaId);
    if (bookmark && bookmark.percent < 90) {
        playbackOptions.startAt = bookmark.duration;
    }

    app.voyoVideo.initForPlay('.player_box video', mediaId, playbackOptions)
        .then(() => {
            app.html.q('.player')?.focus();
        });
}

function mountPlayerSplides(): void {
    if (typeof Splide === 'undefined') {
        return;
    }

    new Splide('.splide.seasons').mount();
    episodesSplide = new Splide('.splide.episodes').mount();
}

function markPlayingEpisode(episodeId: number): void {
    app.html.removeClass('.is-playing', 'is-playing');
    app.html.addClass('[data-uniq="media/' + episodeId + '"]', 'is-playing');

    if (!episodesSplide) {
        return;
    }

    const playingEpisodeEl = app.html.q('[data-uniq="episode-splide/' + episodeId + '"]');
    if (!playingEpisodeEl) {
        return;
    }

    const slideIndex = Array.prototype.indexOf.call(episodesSplide.Components.Elements.slides, playingEpisodeEl);
    if (slideIndex >= 0) {
        episodesSplide.go(slideIndex);
    }
}

function skipTo(seconds: number): void {
    if (!window.app) {
        return;
    }

    app.html.addClass('#start_credits', 'hidden');
    app.html.addClass('#episode_recap', 'hidden');

    app.voyoVideo.setVideoPlayback(seconds);
}

function stopWatching(mediaId: string): void {
    if (!window.app) {
        return;
    }

    const category_url = app.html.getData('.category_page', 'url');

    app.bookmarks.voyoBookmarkRemove('stayedAt', mediaId)
        .then(() => {
            document.location.href = category_url;
        })
        .catch(() => {
            console.log('Failed to remove bookmark');
        });
}

async function onSeasonClick(uniq: string, season: string): Promise<void> {
    if (!window.app) {
        return;
    }

    if (app.html.hasClass('body', 'playing_content')) {
        return playerSeasonClick(uniq, season);
    }

    if (!episodesPlaceholder) {
        return Promise.resolve();
    }

    const current = app.html.q('.season.selected');
    if (!current || app.html.getData(current, 'season') === season) {
        return Promise.resolve();
    }

    app.html.removeClass(current, 'selected');
    app.html.addClass('.season[data-season="'+season+'"]', 'selected');

    return app.voyo.loadSeasonEpisodes(uniq, season, 'episodes', episodesPlaceholder)
        .then(() => {
            if (bookmark) {
                showEpisodeProgress(bookmark.startingEpisodeId, bookmark.percent);
            }
        });
}

function playerSeasonClick(uniq: string, season: string): Promise<void> {
    const placeholder = app.html.q('#season_episodes');
    const current = app.html.q('.season.selected');

    if (!placeholder || (current && app.html.getData(current, 'season') === season)) {
        return Promise.resolve();
    }

    return app.voyo.loadSeasonEpisodes(uniq, season, 'episodes_slider', placeholder)
        .then(() => {
            if (current) {
                app.html.removeClass(current, 'selected');
            }
            app.html.addClass('.season[data-season="'+season+'"]', 'selected');

            if (typeof Splide !== 'undefined') {
                episodesSplide = new Splide('.splide.episodes').mount();
            }
            markPlayingEpisode(playingEpisodeId);
        });
}

function onSeasonInfoClick(event: Event, templateId: string): void {
    event.stopPropagation();
    event.preventDefault();

    if (!window.app) {
        return;
    }

    app.voyo.showStaticContentDetails(templateId);
}

function muteUnmuteTrailerVolume(event: Event) {
    if (!window.app) {
        return;
    }

    app.voyoVideo.muteUnmuteTrailerVolume(event);
}

window.addEventListener('beforeunload', () => {
    if (window.app) {
        app.voyoVideo.stopVideoPlayers();
    }
});

window.playInPlace = playInPlace;
window.onPlayClick = onPlayClick;
window.stopWatching = stopWatching;
window.onSeasonClick = onSeasonClick;
window.onSeasonInfoClick = onSeasonInfoClick;
window.muteUnmuteTrailerVolume = muteUnmuteTrailerVolume;
window.playEpisode = playEpisode;
window.skipTo = skipTo;
